<template>
  <div v-if="!loading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('questions.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">{{$t('questions.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-4">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <mainloader v-if="loading" />
          </div>
        </div>
        <div class="text-center">
          <errorAlert v-if="hasError" :alertMessage="message" />
        </div>

        <div class="row" v-for="(q, indx) in rows" :key="`q_${q.indx}`">
          <div v-if="q.rows.length > 0" class="col-12 border-bottom mb-2 pb-2 fw-bold fs-5">
            <i class="fa-regular fa-circle-question"></i> 
            <span class="mx-2">{{ q.name }}</span>
          </div>
          <div v-if="q.rows.length > 0" class="col-12 mb-4">
            <div class="row py-2 justify-content-center" v-for="(row,index) in q.rows" :key="index">  
              <div class="col-12">
                <div class="accordion" :id="row.id" >
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${row.id}`" aria-expanded="false" :aria-controls="`collapse${row.id}`">
                        <span class="ms-3">
                          <img src="/assets/images/icons/Question-1.png" class="questions-img" alt="">
                        </span>
                        <span class="questions-text">{{row.question}}</span>
                      </button>
                    </h2>
                    <div :id="`collapse${row.id}`" class="accordion-collapse collapse" :data-bs-parent="row.id">
                      <div class="accordion-body">
                        <strong class="preLine">{{row.answer}}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "questions",
  data(){
    return {
      loading: true,
      message: "",
      hasError: false,
      rows: [],
      userLang: 'ar',
    }
  },
  methods:{
    questionsFN(){
      this.hasError = false;
      this.$http.get("/api/questions/listWithCategory").then(res => {
        // console.log(res);
        this.rows = res.data.rows;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
    }
  },
  created(){
    this.questionsFN();
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>